import { mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8dfb47a4")

_pushScopeId("data-v-8dfb47a4")
const _hoisted_1 = { class: "no-label-edit-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editbox_error_message = _resolveComponent("editbox-error-message")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", _mergeProps(_ctx.$props, {
      type: _ctx.inputType,
      class: _ctx.inputClass,
      disabled: _ctx.readonly,
      value: _ctx.modelValue,
      ref: "focusRef",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur', $event.target.value))),
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, ["type", "disabled", "value"]),
    _createVNode(_component_editbox_error_message, null, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.validation), 1)
      ]),
      _: 1
    })
  ]))
})